import $ from 'jquery';
import React,{useEffect,useState} from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useSearchParams,Link,useParams } from 'react-router-dom';

import {btnSetColor_CBack,CallMapMethod,RespBkMthdMapp,AjaxCallMethod,
    GetImgCertUser,sortListNew,TableDatePicker,CallMapMethod_CBack,appGetUrlPath} from '../function_lib/common_lib';
import {getRoleDetails,CallCMSMapMethod_CBack,pgIndexLimit,writeJSLib} from '../function_lib/common_cms';

import Front_Header from '../pages/front_header';
// import Footer from './footer';
import Comp_Sf_Footer from '../pages/comp_sf_footer';


import Article_Listing_n from '../sample_comp_v2/article_listing';
import {Home_Banner_n,Home_Banner2Div_n,Home_Banner_WithNews_n} from '../sample_comp_v2/home_banner';
import Article_Blogs_n from '../sample_comp_v2/article_blogs';
import Left_Img_Txt_Desc_n from '../sample_comp_v2/left_img_txt_desc';
import Single_Img_Msg_n from '../sample_comp_v2/single_img_msg';
import Txt_Description_n from '../sample_comp_v2/txt_description';
import ImageGallery_n from '../sample_comp_v2/image_gallery';
import Video_Slider_n from '../sample_comp_v2/video_slider';
import {Testimonials_n} from '../sample_comp_v2/testimonials';
import Image_Collarge_Grid_n from '../sample_comp_v2/image_collarge_grid';
import Text_Thumbnail_n from '../sample_comp_v2/text_thumbnail';
import Comp_Group_Page from '../sample_comp_v2/comp_group_page';
import {Collapse_Pan_n,Collapse_Pan_Images_n} from '../sample_comp_v2/collapse_pan';
import Card_List from '../sample_comp_v2/card_list';
import Comp_Ashtech_Main_Banner from '../sample_comp_v2/comp_ashtech_main_banner';

import Blog_Listing_New from '../sample_comp_v2/blog_listing_new';

import Product_Slider from '../sample_comp_v2/product_slider';

import Account_Opt_Link from './account_opt_link';
import Comp_Biodata_Template8 from '../sample_comp_v2/comp_biodata_template8';

import user_default from '../assets/images/user_icon.png';
import '../pages/contact_us.css';
import './my_profile.css';


export const My_Profile=()=>{
    let appUrlMedPath=appGetUrlPath();
    const location = useLocation();
    let checkLoadJs=0;
   
    const [logInObj,setLoginObj]=useState([]);

     const [loc,setLoc]=useState('');
    const [stPgData,setStPgData]=useState([]);
    const [_pgIndexed,setPgIndexed]=useState([]);

    const [useJSList,setJsList]=useState(0);

    const [stMyProfile,setMyProfile]=useState([]);


    // member page stacks
    const [stGotraList,setGotraList]=useState([]);
    const [stStates,setStates]=useState([]);

    const getStates=()=>{
        let pgMap=[];
        pgMap.push({name:"curl_type",value:"getStates"});
        pgMap.push({name:"res_func",value:"callBackpgDataNew"});
        pgMap.push({name:"only_cms",value:"d"});
        
       
        pgMap["res_func"]="callBackpgDataNew";
        pgMap["curl_type"]="getStates";
        CallMapMethod_CBack(this,pgMap,function(data,msg){
            if(data!=="0"){
                let jsList=JSON.parse(data);
                setStates(jsList);
            }
        })
    }

    const getGotraList=()=>{
        
        let pgMap=[];
        pgMap.push({name:"curl_type",value:"getGotraList"});
        pgMap.push({name:"res_func",value:"callBackpgDataNew"});
        pgMap.push({name:"only_cms",value:"d"});
        
       
        pgMap["res_func"]="callBackpgDataNew";
        pgMap["curl_type"]="getGotraList";
        CallMapMethod_CBack(this,pgMap,function(data,msg){
            if(data!=="0"){
                let jsList=JSON.parse(data);
                setGotraList(jsList);
            }
        })
    }

    //contact request --
   const updMemeberReq=()=>{
    //return;
    // alert("Thanks for your Registration, Out team will contact soon, for the verification process.");
    // window.location.reload();
        btnSetColor_CBack(this,"upd-member-form","update_profile",function(data,msg){
          // alert(msg);
            if(data==="-10" || data===-10){
                alert(msg);
            }else if(data!=="0"){
                alert(msg);
                window.location.reload();
            }
        })
    }

    // CMS data calling
    const getCMSData=(_loc)=>{
        
        //alert(_loc);
        var pgMap=[];
        pgMap.push({name:"curl_type",value:"getPgData"});
        pgMap.push({name:"res_func",value:"callBackpgDataNew"});
        pgMap.push({name:"loc",value:_loc});
        pgMap.push({name:"only_cms",value:"d"});
        
       
        pgMap["res_func"]="callBackpgDataNew";
        pgMap["curl_type"]="getPgData";
        CallCMSMapMethod_CBack(this,pgMap,function(data,msg){
            //alert(data);
            let listObj=JSON.parse(data);
            setStPgData(listObj.access);
            

            if(useJSList===0 && checkLoadJs===0)
                {
                    //alert("i m in load");
                    checkLoadJs=1;
                writeJSLib();
                setJsList(1);
            }

            AjaxCallMethod(this,"okSuccCNOT");
        });
        
    }

    const getMyProfile=()=>{
        
        let pgMap=[];
        pgMap.push({name:"curl_type",value:"getMyProfile"});
        pgMap.push({name:"res_func",value:"callBackpgDataNew"});
        pgMap.push({name:"only_cms",value:"d"});
        pgMap.push({name:"mem_key",value:logInObj[0]["id"]});
        
       
        pgMap["res_func"]="callBackpgDataNew";
        pgMap["curl_type"]="getMyProfile";
        
        CallMapMethod_CBack(this,pgMap,function(data,msg){
            if(data!=="0"){
                // alert(data);
                let jsList=JSON.parse(data);
                setMyProfile(jsList);
            }
        })
    }

    
    const changeFileHandler=(e)=>{
        let mapData=[];
        const file = e.target.files[0];
        //alert(e.target.value);
        if (file) {
            //alert("i min file");
            var URL = window.URL || window.webkitURL;
            //var fileURL = URL.createObjectURL(file);
            //JSON.stringify(fileURL);
            var reader = new FileReader();

           reader.onloadend = (re) => {
      const base64String = reader.result;
       //alert(base64String);
       mapData.push({name:"local_token",value:logInObj[0]["id"]});
       mapData.push({name:"pro_pic",value:base64String});
       mapData.push({name:"res_func",value:"callBackpgDataNew"});
       mapData.push({name:"curl_type",value:"uploadProPic"});
       mapData.push({name:"upd_for",value:"profile"});

       mapData["res_func"]="callBackpgDataNew";
       mapData["curl_type"]="uploadProPic";

       CallMapMethod_CBack(this,mapData,function(data,msg){
        alert(msg);
        window.location.reload();
       })
      // Now you can use `base64String` (e.g., set to state or send to API)
    };

    reader.readAsDataURL(file);
     
        }

    }

    const changeFileHandlerOtherPic=(e)=>{
        let mapData=[];
        const file = e.target.files[0];
        //alert(e.target.value);
        if (file) {
            //alert("i min file");
            var URL = window.URL || window.webkitURL;
            //var fileURL = URL.createObjectURL(file);
            //JSON.stringify(fileURL);
            var reader = new FileReader();

           reader.onloadend = (re) => {
      const base64String = reader.result;
       //alert(base64String);
       mapData.push({name:"local_token",value:logInObj[0]["id"]});
       mapData.push({name:"pro_pic",value:base64String});
       mapData.push({name:"res_func",value:"callBackpgDataNew"});
       mapData.push({name:"curl_type",value:"uploadProPic"});
       mapData.push({name:"upd_for",value:"other"});

       mapData["res_func"]="callBackpgDataNew";
       mapData["curl_type"]="uploadProPic";

       CallMapMethod_CBack(this,mapData,function(data,msg){
        alert(msg);
        window.location.reload();
       })
      // Now you can use `base64String` (e.g., set to state or send to API)
    };

    reader.readAsDataURL(file);
     
        }

    }
   

    useEffect(()=>{
    
        if(localStorage.getItem("userDS")!=null){
            setLoginObj(JSON.parse(localStorage.getItem("userDS")))
           
         // alert(JSON.stringify(localStorage.getItem("userDS")))
          }
        setPgIndexed(pgIndexLimit());
        getGotraList();
        getStates();
        //alert(location["pathname"].substr(1));
        //setLocation(useLocation());
        //setLoc();
        let _loc=location["pathname"].substr(1);
        if(_loc===""){
            _loc="home";
        }
        setLoc(_loc);
       
      
        //alert(loc);
        getCMSData(_loc);
        
    },[])
    useEffect(()=>{
       
         if(stGotraList.length>0){
            getMyProfile();
         }
        
    },[stGotraList])

return(<>
 
    {/* <!-- Navbar & Carousel End --> */}

<Front_Header loc={loc}/>
    {/* add cms componet */}
    {_pgIndexed.map((item_m,mi)=>{
       // alert(mi+"=== "+_pgIndexed.length);
        if(mi===_pgIndexed.length-1){
         //  alert("i m in set state");
          // setJsList(1);
       }
                if(mi===6){
                    if(typeof stPgData[mi]!=="undefined"){
                        //alert(JSON.stringify(this.state.stPgData[mi]));
                    }
                    
                }
return(<>{typeof stPgData[mi]!=="undefined"?<>
    {/*not in use <Home_Banner_n/> */}
    
    {typeof stPgData[mi]["home_banner"]!=="undefined"?<Home_Banner_WithNews_n lsData={stPgData[mi]["home_banner"]} />:''}
    {typeof stPgData[mi]["home_banner2div"]!=="undefined"?<Home_Banner2Div_n lsData={stPgData[mi]["home_banner2div"]} />:''}
    {typeof stPgData[mi]["list_slider"]!=="undefined"?<Article_Blogs_n lsData={stPgData[mi]["list_slider"]} />:''}

    {typeof stPgData[mi]["card_list"]!=="undefined"?<Card_List lsData={stPgData[mi]["card_list"]} />:''}
    
    {typeof stPgData[mi]["img_text_desc_img_left"]!=="undefined"?<Left_Img_Txt_Desc_n lsData={stPgData[mi]["img_text_desc_img_left"]} />:''}
    {typeof stPgData[mi]["img_text_desc_img_right"]!=="undefined"?<Left_Img_Txt_Desc_n lsData={stPgData[mi]["img_text_desc_img_right"]} img_right="true" />:''}
    
    {typeof stPgData[mi]["image_collarge_grid"]!=="undefined"?<Image_Collarge_Grid_n lsData={stPgData[mi]["image_collarge_grid"]} />:''}
    {typeof stPgData[mi]["video_slider"]!=="undefined"?<Video_Slider_n lsData={stPgData[mi]["video_slider"]} />:''}

    {typeof stPgData[mi]["text_thumbnail"]!=="undefined"?<Text_Thumbnail_n lsData={stPgData[mi]["text_thumbnail"]} />:''}

    {typeof stPgData[mi]["text_description"]!=="undefined"?<Txt_Description_n lsData={stPgData[mi]["text_description"]} />:''}

    {typeof stPgData[mi]["article_listing"]!=="undefined"?<Article_Listing_n isSort={loc==="e_news"?true:false} sortparam={["entry_date",false,"date"]} lsData={stPgData[mi]["article_listing"]} />:''}

    {typeof stPgData[mi]["blog_listing"]!=="undefined"?<Blog_Listing_New isSort={loc==="e_news"?true:false} sortparam={["entry_date",false,"date"]} lsData={stPgData[mi]["blog_listing"]} />:''}

    {typeof stPgData[mi]["single_img_text"]!=="undefined"?<Single_Img_Msg_n lsData={stPgData[mi]["single_img_text"]} />:''}

    {typeof stPgData[mi]["image_gallery"]!=="undefined"?<ImageGallery_n lsData={stPgData[mi]["image_gallery"]} />:''}

    {typeof stPgData[mi]["collapse_pan"]!=="undefined"?<Collapse_Pan_Images_n lsData={stPgData[mi]["collapse_pan"]}/>:''}
    
    {typeof stPgData[mi]["testimonials"]!=="undefined"?<Testimonials_n lsData={stPgData[mi]["testimonials"]}/>:''}
    
    
    </>:''}</>);
   
        })
        }
        {/* end of cms part */}

        <div className="container-sm container-fluid px-1 py-5 mx-auto">
       
            <Account_Opt_Link/>
                
                
                
    {/* my profile */}
    {stMyProfile.length>0?<div class="row">
      <div class="col-md-4">

            <div class="card card-primary card-outline">
              <div class="card-body box-profile">
                {/* <div class="text-center mb-5">Member Id: <b>{atob(logInObj[0]["mem_no"])}</b></div> */}
                <div class="text-center">
                <input onChange={changeFileHandler} id='profilepic' name="profilepic" type="file" hidden accept='image/*' capture />
<label htmlFor="profilepic"><i class="fa fa-camera fa-1x" aria-hidden="true"></i>Upload Pic</label>
                </div>
                <div class="text-center">

                  <img class="profile-user-img img-fluid img-circle"
                       src={stMyProfile[0]["pro_pic"]===""?user_default:appUrlMedPath+stMyProfile[0]["pro_pic"]}
                       alt="User profile picture" />
                      
                </div>

                <h4 class="profile-username text-center">{stMyProfile[0]["mem_name"]}</h4>
                <p class="text-muted text-center">{stMyProfile[0]["occupation"]}</p>
                

                <ul class="list-group list-group-unbordered mb-3">
                <li class="list-group-item">
                    <b>Member ID</b> <a class="float-right">{stMyProfile[0]["account_info_id"]}</a>
                  </li>
                  <li class="list-group-item">
                    <b>Email</b> <a class="float-right">{stMyProfile[0]["email_id"]}</a>
                  </li>
                  <li class="list-group-item">
                    <b>Contact No</b> <a class="float-right">{stMyProfile[0]["contact_no"]}</a>
                  </li>
                 
                </ul>

                
              </div>
              
            </div>
            {/* upload profile pic */}
            <div class="card card-primary card-outline">
              <div class="card-body box-profile">
                

                <h4 class="profile-username text-center">Upload your images</h4>
                <p class="text-muted text-center">{"all uploaded images will be visible to accepted members only"}</p>
                

                <input onChange={changeFileHandlerOtherPic} id='profilepic_lib' name="profilepic_lib" type="file" hidden accept='image/*' capture />
<label htmlFor="profilepic_lib"><i class="fa fa-camera fa-2x" aria-hidden="true"></i>Click here to upload</label>
                
              </div>
              <div class="row">
              {stMyProfile[0]["other_pic"].split(',').map((itemPic,picIndex)=>{
                if(itemPic!==""){
                    return <div class="col-md-6">
                        <img class="w-100 p-2" src={appUrlMedPath+itemPic} />
                    </div>
                }
               
              })}
                
                
              </div>
              
            </div>
            

           
            </div>

{/* form cols */}
            <div class="col-md-8">
            <div class="card card-primary card-outline">
                <div class="card-body box-profile">

                <form className="contact-form-style form-control11 " name="upd-member-form" id="upd-member-form">
    <input type="hidden" name="curl_type" id="curl_type" value="update_profile" />  
                <input type="hidden" name="m_type" id="m_type" value="update_profile" />
                <input type="hidden" name="res_func" id="res_func" value="okSuccCont" />
                <input type='hidden' name="local_token" id="local_token" value={logInObj[0]["id"]}/>
        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Name:</strong></label>
                <input name="first_name" id="first_name" type="text" defaultValue={stMyProfile[0]["mem_name"]} class="form-control required" placeholder="Enter full name" required/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Gender:</strong></label>
                <select className='form-control required' id="gender" name="gender">
                    <option value={"0"}>-Select-</option>
                    <option selected={stMyProfile[0]["gender"]==="Male"} value={"Male"}>Male</option>
                    <option selected={stMyProfile[0]["gender"]==="Female"} value={"Female"}>Female</option>
                </select>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Date of Birth:</strong></label>
                <TableDatePicker refDate={stMyProfile[0]["fmt_dob"]} class="form-control required" refName="dob"/>
                {/* <input name="date_of_birth" type="date" class="form-control required" /> */}
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Birth Time:</strong></label>
                <input name="time" id="time" type="time" defaultValue={stMyProfile[0]["fmt_time"]} class="form-control required" required/>
            </div>

            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Birth Place:</strong></label>
                <input name="birth_place" defaultValue={stMyProfile[0]["birth_place"]} id="birth_place" type="text" class="form-control required" placeholder="Enter birth place" required/>
            </div>

            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Height (in cm):</strong></label>
                <input name="height" id="height" defaultValue={stMyProfile[0]["height"]} type="number" class="form-control required" placeholder="Enter height" required/>
            </div>

            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Skin Colour:</strong></label>
                <select className='form-control required' id="skin_color" name="skin_color">
                    <option value={"0"}>-Select-</option>
                    <option selected={stMyProfile[0]["skin_color"]==="Fair"} value={"Fair"}>Fair</option>
                    <option selected={stMyProfile[0]["skin_color"]==="Light"} value={"Light"}>Light</option>
                    <option selected={stMyProfile[0]["skin_color"]==="Medium"} value={"Medium"}>Medium</option>
                    <option selected={stMyProfile[0]["skin_color"]==="Dark"} value={"Dark"}>Dark</option>
                </select>
                
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Highest Qualification:</strong></label>
                <select className='form-control required' id="max_qualification" name="max_qualification">
                    <option value={"0"}>-Select-</option>
                    <option selected={stMyProfile[0]["max_qualification"]==="12th"} value={"12th"}>12th</option>
                    <option selected={stMyProfile[0]["max_qualification"]==="Graduation"} value={"Graduation"}>Graduation</option>
                    <option selected={stMyProfile[0]["max_qualification"]==="Post Graduation"} value={"Post Graduation"}>Post Graduation</option>
                    <option selected={stMyProfile[0]["max_qualification"]==="Engineering"} value={"Engineering"}>Engineering</option>
                    <option selected={stMyProfile[0]["max_qualification"]==="Medicine"} value={"Medicine"}>Medicine</option>
                    <option selected={stMyProfile[0]["max_qualification"]==="Law"} value={"Law"}>Law</option>
                    <option selected={stMyProfile[0]["max_qualification"]==="Management"} value={"Management"}>Management</option>
                    <option selected={stMyProfile[0]["max_qualification"]==="Doctor"} value={"Doctor"}>Doctor</option>
                    <option selected={stMyProfile[0]["max_qualification"]==="Other Diploma"} value={"Other Diploma"}>Other Diploma</option>
                </select>
                
            </div>
           
        </div>
    
        <div class="form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Highest Qualification Details:</strong></label>
            <input name="max_qualification_det" defaultValue={stMyProfile[0]["max_qualification_det"]} id="max_qualification_det" type="text" class="form-control required" placeholder="Enter Qualification Degree/College/University Name" required/>
        </div>

        <div class="form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Occupation:</strong></label>
            <input name="occupation" id="occupation" defaultValue={stMyProfile[0]["occupation"]} type="text" class="form-control required" placeholder="Enter occupation"/>
        </div>
        <div class="row">
        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>State:</strong></label>
            <select className='form-control required' id="state_nm" name="state_nm">
                    <option value={"0"}>-Select-</option>
                    {stStates.map((item,index)=>{
                        return <option selected={stMyProfile[0]["state_nm"]===item["name"]} value={item["name"]}>{item["name"]}</option>
                    })}
                  
                </select>
        </div>
        

        
        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>City:</strong></label>
            <input type='text' name="city_nm" id="city_nm" defaultValue={stMyProfile[0]["city_nm"]} class="form-control required" placeholder='City Name' />
        </div>
        <div class="col-md-12 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Address:</strong></label>
            <textarea name="address" id="address" defaultValue={stMyProfile[0]["address"]} class="form-control required" placeholder="Enter full address" rows="2" required></textarea>
        </div>
        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Landmark:</strong></label>
            <input type='text' name="landmark" id="landmark" defaultValue={stMyProfile[0]["landmark"]} class="form-control required" placeholder='Landmark' />
        </div>

        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Pincode:</strong></label>
            <input type='text' name="pincode" id="pincode" defaultValue={stMyProfile[0]["pincode"]} class="form-control required" placeholder='Pincode' />
        </div>

        </div>

        

        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Mobile No.:</strong></label>
                <input name="contact_no" id="contact_no" defaultValue={stMyProfile[0]["contact_no"]} type="tel"  class="form-control required" placeholder="Enter mobile number" required/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Email ID:</strong></label>
                <input name="email" id="email" type="email" defaultValue={stMyProfile[0]["email_id"]} class="form-control required" placeholder="Enter email address"/>
            </div>
        </div>

        <h4 class="mt-4">Family Details</h4>

        <div class="row">
        
        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Father's Name:</strong></label>
                <input name="father_nm" id="father_nm" defaultValue={stMyProfile[0]["father_nm"]} type="text" class="form-control required" placeholder="Enter father's name" required/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Mother's Name:</strong></label>
                <input name="mother_name" id="mother_name" defaultValue={stMyProfile[0]["mother_name"]} type="text" class="form-control required" placeholder="Enter mother's name" required/>
            </div>
           
        
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Father's Occupation:</strong></label>
                <input name="father_occup" id="father_occup" defaultValue={stMyProfile[0]["father_occup"]} type="text" class="form-control required" placeholder="Enter father's occupation"/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Father's Mobile No.:</strong></label>
                <input name="father_contact" id="father_contact" defaultValue={stMyProfile[0]["father_contact"]} type="tel" class="form-control required" placeholder="Enter father's mobile"/>
            </div>
            <div class="row">
                <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                    <label class="float-left"><strong>Mother's Occupation:</strong></label>
                    <input name="mother_occup" id="mother_occup" type="text" defaultValue={stMyProfile[0]["mother_occup"]} class="form-control required" placeholder="Enter mother's occupation"/>
                </div>
                <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                    <label class="float-left"><strong>Mother's Mobile No.:</strong></label>
                    <input name="mother_contact" id="mother_contact" type="tel" defaultValue={stMyProfile[0]["mother_contact"]} class="form-control required" placeholder="Enter mother's mobile"/>
                </div>
            </div>
        </div>

        <h4 class="mt-4">Income</h4>
        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Family Annual Income:</strong></label>
                
                <select className='form-control required' id="family_anum" name="family_anum">
                    <option value={"0"}>-Select-</option>
                    <option selected={stMyProfile[0]["family_anum"]==="6.00"} value={"6"}>5 to 6 lac per year</option>
                    <option selected={stMyProfile[0]["family_anum"]==="8.00"} value={"8"}>6 to 8 lac per year</option>
                    <option selected={stMyProfile[0]["family_anum"]==="10.00"} value={"10"}>8 to 10 lac per year</option>
                    <option selected={stMyProfile[0]["family_anum"]==="15.00"} value={"15"}>10 to 15 lac per year</option>
                    <option selected={stMyProfile[0]["family_anum"]==="20.00"} value={"20"}>15 to 20 lac per year</option>
                    <option selected={stMyProfile[0]["family_anum"]==="40.00"} value={"40"}>30 to 40 lac per year</option>
                    
                    <option selected={stMyProfile[0]["family_anum"]==="41.00"} value={"41"}>Greater than 40 lac per year</option>
                </select>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Self Annual Income:</strong></label>
                <select className='form-control required' id="self_anum" name="self_anum">
                    <option value={"0"}>-Select-</option>
                    <option selected={stMyProfile[0]["self_anum"]==="6.00"} value={"6"}>5 to 6 lac per year</option>
                    <option selected={stMyProfile[0]["self_anum"]==="8.00"} value={"8"}>6 to 8 lac per year</option>
                    <option selected={stMyProfile[0]["self_anum"]==="10.00"} value={"10"}>8 to 10 lac per year</option>
                    <option selected={stMyProfile[0]["self_anum"]==="15.00"} value={"15"}>10 to 15 lac per year</option>
                    <option selected={stMyProfile[0]["self_anum"]==="20.00"} value={"20"}>15 to 20 lac per year</option>
                    <option selected={stMyProfile[0]["self_anum"]==="40.00"} value={"40"}>30 to 40 lac per year</option>
                    <option selected={stMyProfile[0]["self_anum"]==="41.00"} value={"41"}>Greater than 40 lac per year</option>
                </select>
                {/* <input name="self_anum" id="self_anum" type="number" class="form-control required" placeholder="Self Annual Income"/> */}
            </div>
        </div>

        <h4 class="mt-4">Goutra</h4>
        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Self Goutra:</strong></label>
                <select className='form-control required' id="self_goutra" name="self_goutra">
                    <option value={"0"}>-Select-</option>
                    {stGotraList.map((item,index)=>{
                        return <option selected={stMyProfile[0]["self_goutra"]===item["temple_name"]} value={item["temple_name"]}>{item["temple_name"]}</option>
                    })}
                </select>
                
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Mama Goutra:</strong></label>
                <select className='form-control required' id="mama_goutra" name="mama_goutra">
                    <option value={"0"}>-Select-</option>
                    {stGotraList.map((item,index)=>{
                        return <option selected={stMyProfile[0]["mama_goutra"]==item["temple_name"]} value={item["temple_name"]}>{item["temple_name"]}</option>
                    })}
                </select>
            </div>
        </div>
        {/* <h4 class="mt-4">Kuldevi</h4>
        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Self Kuldevi:</strong></label>
                <input name="kuldevi_self" type="text" class="form-control" placeholder="Enter Kuldevi"/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Mama Kuldevi:</strong></label>
                <input name="kuldevi_mama" type="tel" class="form-control" placeholder="Enter Mama Kuldevi"/>
            </div>
        </div> */}
        <h4 class="mt-4">Mangalic Status</h4>
        <div class="row">
        <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="brother_is"><strong>Mangalic Status:</strong></label>
                <select id="mangalic_status" name="mangalic_status" class="form-control select">
                    <option value={"0"}>Select</option>
                    <option selected={stMyProfile[0]["mangalic_status"]==="Mangalic"} value={"Mangalic"}>Mangalic</option>
                    <option selected={stMyProfile[0]["mangalic_status"]==="Anshik Mangalic"} value={"Anshik Mangalic"}>Anshik Mangalic</option>
                    <option selected={stMyProfile[0]["mangalic_status"]==="General"} value={"General"}>General</option>
                    
                </select>
                
            </div>
            <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="brother_is"><strong>Marital Status:</strong></label>
                <select id="marital_status" name="marital_status" class="form-control">
                    <option value={"0"}>Select</option>
                    {/* <option value={"Married"}>Married</option> */}
                    <option selected={stMyProfile[0]["marital_status"]==="Unmarried"} value={"Unmarried"}>Unmarried</option>
                    <option selected={stMyProfile[0]["marital_status"]==="Divorced"} value={"Divorced"}>Divorced</option>
                    <option selected={stMyProfile[0]["marital_status"]==="Widow (विधवा)"} value={"Widow (विधवा)"}>Widow (विधवा)</option>
                    <option selected={stMyProfile[0]["marital_status"]==="Widower (विधुर)"} value={"Widower (विधुर)"}>Widower (विधुर)</option>
                    
                </select>
               
            </div>
        </div>
        <h4 class="mt-4">Siblings Details</h4>
        <div class="row">
            <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="brother_status"><strong>Brother *:</strong></label>
                <select id="brother_status" name="brother_status" class="form-control required">
                    <option value={"0"}>Select</option>
                    <option selected={stMyProfile[0]["brother_status"]==="No Brother"} value={"No Brother"}>No Brother</option>
                    <option selected={stMyProfile[0]["brother_status"]==="Unmarried"} value={"Unmarried"}>Unmarried</option>
                    <option selected={stMyProfile[0]["brother_status"]==="Married"} value={"Married"}>Married</option>
                </select>
                <input name="brother_det" id="brother_det" defaultValue={stMyProfile[0]["brother_det"]} type="text" class="form-control mt-1" placeholder="Enter details if Brother is Married"/>
            </div>
    
            <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="sister_status"><strong>Sister:</strong></label>
                <select id="sister_status" name="sister_status" class="form-control required">
                    <option value={"0"}>Select</option>
                    <option selected={stMyProfile[0]["sister_status"]==="No Sister"} value={"No Sister"}>No Sister</option>
                    <option selected={stMyProfile[0]["sister_status"]==="Unmarried"} value={"Unmarried"}>Unmarried</option>
                    <option selected={stMyProfile[0]["sister_status"]==="Married"} value={"Married"}>Married</option>
                </select>
                <input name="sister_det" id="sister_det" defaultValue={stMyProfile[0]["sister_det"]} type="text" class="form-control mt-1" placeholder="Enter details if Sister is Married"/>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Reference Person 1 Name:</strong></label>
                <input name="ref_one_nm" readOnly={"true"} id="ref_one_nm" defaultValue={stMyProfile[0]["ref_one_nm"]} type="text"  class="form-control" placeholder="Enter name"/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Reference Person 1 Contact:</strong></label>
                <input name="ref_one_contact" readOnly={"true"} id="ref_one_contact" defaultValue={stMyProfile[0]["ref_one_contact"]} type="tel" class="form-control" placeholder="Enter contact number"/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Reference Person 2 Name:</strong></label>
                <input name="ref_two_nm" readOnly={"true"} id="ref_two_nm" defaultValue={stMyProfile[0]["ref_two_nm"]} type="text" class="form-control" placeholder="Enter name"/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Reference Person 2 Contact:</strong></label>
                <input name="ref_two_contact" readOnly={"true"} id="ref_two_contact" defaultValue={stMyProfile[0]["ref_two_contact"]} type="tel" class="form-control" placeholder="Enter contact number"/>
            </div>

            {/* <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="registered_by"><strong>Registered By:</strong></label>
                <select id="registered_by" name="registered_by" class="form-control required">
                    <option>Select</option>
                    <option selected={stMyProfile[0]["registered_by"]==="Self"} value={"Self"}>Self</option>
                    <option selected={stMyProfile[0]["registered_by"]==="Parents"} value={"Parents"}>Parents</option>
                    
                    
                </select>
                
            </div> */}
        </div>

        <div class="text-center mt-4">
            <button type="button" onClick={()=>updMemeberReq()} class="btn btn-primary me-2">Update</button>
            {/* <button type="reset" class="btn btn-secondary">Reset</button> */}
        </div>
    </form>


                </div>
            </div>

            </div>
            
            {/* row end */}
            </div>
            :''}
    {/* my profile */}
    
    


                
            </div>
      
        {/* <Footer/> */}
        <Comp_Sf_Footer/>
</>)
}
export default My_Profile;